import React from "react";
import { Row, Col, Container } from "reactstrap";
import COLORS from "../../../../common/colors";
import FacebookIcon from "../../elements/icons/facebookIcon";
import TwitterIcon from "../../elements/icons/twitterIcon";
import InstagramIcon from "../../elements/icons/instagramIcon";
import LinkedinIcon from "../../elements/icons/linkedinIcon";
import { ToggleButton } from "../../elements/buttons";
import NoSSR from "../../elements/noSSR";
import NewsletterFooter from "./newsletterFooter";
import RequestInfoContext from "../../../common/requestInfoContext";
import getConfig from "next/config";
const config = getConfig().publicRuntimeConfig;

const _getLocalStore = (name) => {
  try {
    return JSON.parse(localStorage.getItem(name));
  } catch (err) {
    return null;
  }
};

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    const { session } = props;

    let currentCurrency = "INR";
    const localStoreCurrency = _getLocalStore("currentCurrency");
    if (localStoreCurrency) {
      currentCurrency = localStoreCurrency;
    } else if (session && session.currentCurrency) {
      currentCurrency = session.currentCurrency;
    } else if (session && session.country) {
      currentCurrency = session.country;
    }
    if (currentCurrency === "INR" || currentCurrency === "IN") {
      this.state = {
        currency: "INR",
        toggle: false,
      };
    } else {
      this.state = {
        currency: "USD",
        toggle: true,
      };
    }
  }
  toggleButton = () => {
    const currency = this.state.toggle ? "INR" : "USD";
    this.setState({
      toggle: !this.state.toggle,
    });
    this.changeCurrentCurrency(currency);
  };

  changeCurrentCurrency = (e) => {
    localStorage.setItem("currentCurrency", JSON.stringify(e));
    localStorage.setItem("isCurrencyChanged", true);
    // TODO Add case to handle US and USA here.

    this.setState({
      currency: e,
    });

    if (window.eventDispatcher) {
      window.eventDispatcher.dispatchEventSync(
        "currencyToggle",
        {},
        { amplitude: true }
      );
    }

    window.location.reload();
  };

  render() {
    return (
      <Container className="footer" id="footer">
        <Row className="footer-top  d-flex" style={{ paddingTop: "2rem" }}>
          <Col
            xs="12"
            md="12"
            lg="3"
            sm="12"
            className="d-flex justify-content-center align-self-center footer-height-for-mobile  ft-menu"
          >
            <Row className="footer-column">
              <Col
                className="footer-panel-f3"
                xs="12"
                style={{ overflow: "hidden" }}
              >
                <Row>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="https://support.giveindia.org/support/home"
                        target="_blank"
                        className="no-hover-a footer-link"
                      >
                        Help
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a href="/aboutus" className="no-hover-a footer-link">
                        About Us
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="/certified-indian-ngos"
                        className="no-hover-a footer-link"
                      >
                        Partner NGOs
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a href="/giveassured" className="no-hover-a footer-link">
                        GiveAssured
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="https://blog.giveindia.org"
                        className="no-hover-a footer-link"
                      >
                        Blog
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="/careers"
                        //"https://giveindia.zohorecruit.com/jobs/Careers"
                        target="_blank"
                        className="no-hover-a footer-link"
                      >
                        Careers
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a href="/contactus" className="no-hover-a footer-link">
                        Contact Us
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a href="/all-ngos/" className="no-hover-a footer-link">
                        NGOs in India
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="https://workplace.giveindia.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-hover-a footer-link"
                      >
                        Workplace Giving
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href={`${config.fundraisersPlatformUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-hover-a footer-link"
                      >
                        Fundraisers
                      </a>
                    </p>
                  </Col>
                  <Col xs="4" md="6" className="footer-right">
                    <p>
                      <a
                        href="https://gi.giveindia.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-hover-a footer-link"
                      >
                        Previous platform
                      </a>
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col className="ft-newsletter p-0" xs="12" md="12" lg="7" sm="12">
            <NewsletterFooter />
          </Col>
          <Col
            className="ml-auto currency-input align-self-center fc-toggle"
            xs="12"
            md="12"
            lg="2"
            sm="12"
          >
            <NoSSR>
              <div className="currency-input text-center">
                <ToggleButton
                  toggleButton={this.toggleButton}
                  toggle={this.state.toggle}
                  classNames={
                    this.state.toggle
                      ? "btn btn-toggle active no-hover"
                      : "btn btn-toggle no-hover"
                  }
                />
              </div>
            </NoSSR>
          </Col>
        </Row>
        {/* <Row className="partners-logo-panel footer-bottom d-flex f-d-col">
					<p className="test-muted">Partners</p>
					<div className="mb-2">
						<img src={`${config.cdnUrl}/static/images/partners/logo/fankind_logo.svg`} />
					</div>
				</Row> */}

        <Row className="footer-bottom">
          <RequestInfoContext.Consumer>
            {(requestInfo) => {
              if (requestInfo.path.match(/^\/$/)) {
                return (
                  <Col
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    className="p-0 footer-divider-bottom"
                  >
                    <h1 style={{ fontSize: "16px", color: "#999999" }}>
                      GiveIndia, India’s most trusted online donation platform
                    </h1>
                    {/*<p style={{ paddingTop: '0rem'}} >GiveIndia is India's largest and most trustworthy giving platform for donors. With contributions of over ₹450+ crore from 13 lakh donors and 150+ corporates, supporting 1,250+ nonprofits and impacting 45 lakh lives across 23 states in India.</p>*/}
                    {/* <p style={{ paddingTop: '0rem'}}>Through our Online Giving platform, we bring both convenience and choice together for donors in a safe and high-trust environment. Our Online Giving platform alone has contributed more than 100 crores so far to 500+ donation options across our partner NGOs.</p> */}
                    <p style={{ paddingTop: "0rem", paddingBottom: "10px" }}>
                      On our platform, you can donate to a nonprofit with
                      confidence. Our robust due diligence process covers legal,
                      compliance, financial and impact checks for each donation
                      made to any non-profit, including in-person visits to
                      beneficiaries and actual feedback reports. We do all this
                      so that our donors can trust that their giving is indeed
                      doing what it's supposed to do - change lives.
                    </p>
                    <h2
                      style={{
                        fontSize: "16px",
                        marginBottom: "0rem",
                        color: "#999999",
                      }}
                    >
                      Here is why you should donate through GiveIndia:
                    </h2>
                    <p style={{ paddingTop: "8px" }}>
                      <ul>
                        <li>Choice: 200+ organizations to donate to</li>
                        <li>Simple: Give at a click of a button</li>
                        <li>Convenience: Contribute monthly with ease</li>
                        <li>
                          Credible - Donate with confidence to the verified
                          partner NGOs of GiveIndia
                        </li>
                        <li>
                          Scale - Make a big impact with your small amounts.
                          Donate as little as Rs.110/ month
                        </li>
                        <li>
                          Tax exemption - Receive instant e-receipt on every
                          donation, to claim tax
                        </li>
                      </ul>
                    </p>
                  </Col>
                );
              }
              return null;
            }}
          </RequestInfoContext.Consumer>

          <div className="footer-bottom-bar">
            <div className="footer-bottom-left">
              <p className="footer-copyright">
                {" "}
                <span>© GiveIndia</span>{" "}
                <span>
                  Donations through this platform are tax exempted under 80G
                  &amp; 501(c)(3)
                </span>{" "}
              </p>
              <style jsx>
                {`
                  .footer-exempted-span {
                    padding-bottom: 0;
                    padding-top: 10px;
                    width: 100%;
                  }
                `}
              </style>
            </div>
            <div className="footer-bottom-right ">
              <span>
                <a className="no-hover-a" href="/terms">
                  <p>Terms</p>
                </a>
              </span>
              <span>
                <a className="no-hover-a" href="/privacy">
                  <p>Privacy Policy</p>
                </a>
              </span>
              <span>
                <a href="/sitemap">
                  <p>Site Map</p>
                </a>
              </span>
              <div className="footer-bottom_mobile">
                <span>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/GiveIndia/"
                    target="_blank"
                  >
                    <FacebookIcon
                      style={{ display: "flex", alignItems: "center" }}
                      size={20}
                      color={`${COLORS.giveMidGrey}`}
                    />
                  </a>
                </span>
                <span>
                  <a
                    rel="noopener noreferrer"
                    href="https://twitter.com/giveindia/"
                    target="_blank"
                  >
                    <TwitterIcon
                      style={{ display: "flex", alignItems: "center" }}
                      size={20}
                      color={`${COLORS.giveMidGrey}`}
                    />
                  </a>
                </span>
                <span>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/give_india/"
                    target="_blank"
                  >
                    <InstagramIcon
                      style={{ display: "flex", alignItems: "center" }}
                      size={20}
                      color={`${COLORS.giveMidGrey}`}
                    />
                  </a>
                </span>
                <span>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/giveindia/"
                    target="_blank"
                  >
                    <LinkedinIcon
                      style={{ display: "flex", alignItems: "center" }}
                      size={20}
                      color={`${COLORS.giveMidGrey}`}
                    />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}
